import { supabase } from '../../../../supabaseConfig';
import { ISistemaOrigem } from '../../../types/tables/ISistemaOrigem';

/**
 * Serviço para gerenciamento de sistemas de origem
 * Gerencia os sistemas que podem gerar solicitações de pagamento
 * Esta é uma tabela de configuração global (sem multi-tenant)
 */
export class SistemaOrigemService {
     protected client = this.getClient();
     protected tableName = 'sistema_origem';

     private getClient() {
          return supabase;
     }

     /**
      * Busca todos os sistemas ativos
      */
     async getAllActive() {
          return await this.client
               .from('sistema_origem')
               .select('*')
               .eq('ativo', true)
               .order('nome');
     }

     /**
      * Busca sistema por ID
      */
     async getById(id: number) {
          return await this.client
               .from('sistema_origem')
               .select('*')
               .eq('id', id)
               .single();
     }

     /**
      * Busca sistema por código
      */
     async getByCodigo(codigo: string) {
          return await this.client
               .from('sistema_origem')
               .select('*')
               .eq('codigo', codigo)
               .single();
     }

     /**
      * Busca sistema por prefixo
      */
     async getByPrefixo(prefixo: string) {
          return await this.client
               .from('sistema_origem')
               .select('*')
               .eq('prefixo', prefixo)
               .single();
     }

     /**
      * Cria um novo sistema
      */
     async create(sistema: Omit<ISistemaOrigem, 'id' | 'created_at'>) {
          return await this.client
               .from('sistema_origem')
               .insert(sistema)
               .select()
               .single();
     }

     /**
      * Atualiza um sistema
      */
     async update(id: number, updates: Partial<ISistemaOrigem>) {
          return await this.client
               .from('sistema_origem')
               .update(updates)
               .eq('id', id)
               .select()
               .single();
     }

     /**
      * Ativa/desativa um sistema
      */
     async toggleAtivo(id: number) {
          const { data: sistema } = await this.getById(id);
          if (!sistema) throw new Error('Sistema não encontrado');

          // Temporariamente usando any para contornar erro de tipagem
          const sistemaData = sistema as any;
          return await this.update(id, { ativo: !sistemaData.ativo });
     }

     /**
      * Remove um sistema (soft delete)
      */
     async delete(id: number) {
          return await this.client
               .from('sistema_origem')
               .delete()
               .eq('id', id);
     }
}
